<div class="container-fluid-modal">
 <form #f="ngForm" (ngSubmit)="f.form.valid && submitForm()" novalidate>
    <div class="add">
      <div class="ModalHeader">
        <h4 mat-dialog-title>Change Password</h4>
        <div class="headerButton">
          <button type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save </button>
          <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i class="fa fa-times" aria-hidden="true"></i> Cancel
          </button>
        </div>
      </div>
            <mat-dialog-content>
		        <div class="card">
		          <div class="card-body">
		          	<div *ngIf="formValidation">
		            <div class="formError"><h6>{{errorMsg}}</h6> </div>
		            </div>
		            <div class="form-group col-lg-12">
		              <div class="form-group col-lg-12">
		                <label for="Current Password" class="labelRequired">Current Password</label>
		                <input type="password" class="form-control" placeholder="Current Password" name="cPassword" #cPassword="ngModel" [(ngModel)]="curPassword" class="form-control"
		                       required [ngClass]="{ 'is-invalid': f.submitted && cPassword.invalid }">
		                    <div *ngIf="f.submitted && cPassword.invalid" class="invalid-feedback">
				                <div *ngIf="cPassword.errors.required">* Current Password is required</div>
				            </div>
		              </div>
		            </div>
		            <div class="form-group col-lg-12">
		              <div class="form-group col-lg-12">
		                <label for="New Password" class="labelRequired">New Password </label>
		                <input type="password" class="form-control" placeholder="New Password" name="nPassword" [(ngModel)]="newPassword"
		                       required #nPassword="ngModel" [ngClass]="{ 'is-invalid': f.submitted && nPassword.invalid  }">
		                <div *ngIf="f.submitted && nPassword.invalid" class="invalid-feedback">
		                  <div *ngIf="nPassword.errors.required">* New Password is required</div>
		                </div>
		              </div>
		            </div>
		            <div class="form-group col-lg-12">
		              <div class="form-group col-lg-12">
		                <label for="Confirm New Password" class="labelRequired">Confirm New Password</label>
		                <input type="password" class="form-control" placeholder="Confirm New Password" name="confPassword" [(ngModel)]="confNewPassword"
		                        required #confPassword="ngModel" [ngClass]="{'is-invalid': f.submitted && confPassword.invalid }">
		                <div *ngIf="f.submitted && confPassword.invalid" class="invalid-feedback">
		                  <div *ngIf="confPassword.errors.required">* Confirm Password is required</div>
		                </div>
		              </div>
		            </div>
		          </div>
		        </div>
      	    </mat-dialog-content>
        </div>
    </form>
</div>
